import { render, staticRenderFns } from "./VCommentPrintList.vue?vue&type=template&id=4172f4f3&scoped=true&"
import script from "./VCommentPrintList.vue?vue&type=script&lang=js&"
export * from "./VCommentPrintList.vue?vue&type=script&lang=js&"
import style0 from "./VCommentPrintList.vue?vue&type=style&index=0&id=4172f4f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4172f4f3",
  null
  
)

export default component.exports